import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async createDebate(documentID) {
    return await picador.post('createDebate', xhrPath.debate({}), { document_id: documentID });
  },

  async getDebate(debateID) {
    return await picador.post('getDebate', xhrPath.debate({ debateID }));
  },

  async getDebateStatus(debateID) {
    return await picador.get('getDebateStatus', xhrPath.debate({ debateID }) + '/status');
  },

  async getDebateNextState(debateID) {
    return await picador.get('getDebateNextState', xhrPath.debate({ debateID }) + '/next_state');
  },
  async getDebateNextStateCurator(debateID) {
    return await picador.get(
      'getDebateNextStateCurator',
      xhrPath.debates({ debateID }) + '/next_state'
    );
  },

  async getCounterpointForDocument(documentID, publicLinkId) {
    return await picador.get('getCounterpointForDocument', xhrPath.debate({ documentID }), {
      params: { publicLinkId },
    });
  },

  /**
   * Debate Rounds
   */

  async addDebateRound(debateID) {
    return await picador.post(
      'addDebateRound',
      xhrPath.debate({ debateID }) + '/create_new_round',
      { debate_id: debateID }
    );
  },

  async updateRoundStatus(debateID, roundId, status) {
    return await picador.put(
      'updateRoundStatus',
      `${xhrPath.debate({ debateID })}/round_update/${roundId}`,
      { status: status }
    );
  },
  async cloneDebate(debateID, data) {
    return await picador.post('cloneDebate', xhrPath.cloneDebate(debateID), data);
  },

  async continueToNextRound(debateID, teamID, ownerID, isOpposition) {
    const data = isOpposition
      ? {
          opposition_team: teamID,
          opposition_owner: ownerID,
        }
      : {
          team: teamID,
          owner: ownerID,
        };
    return await picador.post(
      'continueToNextRound',
      `${xhrPath.debate({ debateID })}/continue_to_next_round`,
      data
    );
  },
  async continueToNextRoundCurator(debateID, teamID) {
    const data = {
      team_id: teamID,
    };
    return await picador.post(
      'continueToNextRoundCurator',
      `${xhrPath.debates({ debateID })}/continue_to_next_round`,
      data
    );
  },

  /**
   * Annotations
   */

  async getAnnotation(annotationID) {
    return await picador.get('getAnnotation', xhrPath.debate({}) + `/annotation/${annotationID}`);
  },

  async addAnnotation(debateID, roundID, annotationData) {
    return await picador.post(
      'addAnnotation',
      xhrPath.debate({ debateID }) + `/round_annotation/${roundID}`,
      annotationData
    );
  },

  async updateAnnotation(annotationID, annotationData) {
    return await picador.put(
      'updateAnnotation',
      xhrPath.debate({}) + `/update_annotation/${annotationID}`,
      annotationData
    );
  },

  async deleteAnnotation(annotationID) {
    return await picador.delete(
      'deleteAnnotation',
      xhrPath.debate({}) + `/delete_annotation/${annotationID}`
    );
  },

  /**
   * Team Replies
   */

  async addTeamReply(annotationID, teamReplyData) {
    return await picador.post(
      'addTeamReply',
      `${xhrPath.debate({})}/${annotationID}/team_annotation_reply`,
      teamReplyData
    );
  },

  async updateTeamReply(teamReplyID, teamReplyData) {
    return await picador.put(
      'updateTeamReply',
      `${xhrPath.debate({})}/team_annotation_reply/${teamReplyID}`,
      teamReplyData
    );
  },
};
